var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navigation'),_c('div',[_c('cursor-fx',{ref:"cursor",attrs:{"color":"white","outside-size":"7rem","shape":"circle"}}),_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }